import type { Store, ModalDescriptor } from '../types';

type SetState = (partial: Partial<Store> | ((state: Store) => Partial<Store>)) => void;

export function createModalActions(set: SetState) {
  return {
    openModal(descriptor: ModalDescriptor): void {
      set((state) => ({
        modals: {
          stack: [...state.modals.stack, descriptor],
        },
      }));
    },
    closeModal(): void {
      set((state) => {
        const newStack = state.modals.stack.slice(0, -1);
        return {
          modals: {
            stack: newStack,
          },
        };
      });
    },
  };
}
